var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "#ffd700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EdcCFX",
    fill: "#ffd700"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffd700"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd700",
    d: "M95.7,18.3c62.9-3.6,105.3,64.4,76,120.4-29.5,56.4-110.5,57.8-142,2.4C-.4,88.1,35.3,21.7,95.7,18.3ZM91.7,23.3C53.4,27.1,22.3,62.7,23.3,101.5c1.6,63.3,75.4,99.2,124.9,58.5,58.8-48.5,19.3-144.1-56.4-136.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd700",
    d: "M60.1,103c-.5,27.5,23.9,47.9,50.8,40.5,13-3.6,23.9-14.4,27.4-27.5,1.1-4.3.2-13.5,4.9-13,4.3,1.4-1.3,17.2-2.6,20.3-19.5,45.1-87.9,28.7-84.4-20.4h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd700",
    d: "M66.8,61.2c18.4-5.5,19.1,25.6-.8,19.3s-7.1-17,.8-19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd700",
    d: "M125.5,61.2c18.5-4.2,17.3,25-.8,19.3s-8-17.3.8-19.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/face-icon.eab2a12bcc9499cd90c28afdc825727b.svg";
export { ForwardRef as ReactComponent };